// NOTE: this file is a workaround for CSS ordering build issue
// NOTE: don't add more stuff to this one and don't import SchedulerHeader component directly in other places

import React from 'react';

import SchedulerHeader from 'scheduler/components/Header/SchedulerHeader';

import 'styles/common/dropdown.scss';

const SchedulerHeaderWrap = (props) => <SchedulerHeader {...props} />;

export default SchedulerHeaderWrap;
